// extracted by mini-css-extract-plugin
export default {"cartContainer":"Cart_cartContainer__JEwot","fadeUp":"Cart_fadeUp__KmEqD","totalOreder":"Cart_totalOreder__S8ef8","buttonContainer":"Cart_buttonContainer__2Bv+K"};